import '../../UXPages/tsdaStyles.scss';
import { useGetEligiblePatientDataMutation } from 'src/services/eligiblePatients';
import { setMessage } from 'src/store/Message';
import { useAppDispatch } from 'src/store';
import { Box, Tooltip, Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import '../../UXPages/tsdaStyles.scss';
import { useEffect, useState } from 'react';
import { DataTable } from '@pihealth/common-ui-library';

export default function PreScreenFail(props: any) {
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [getEligiblePatientsData, { data, error, isError, isLoading }] = useGetEligiblePatientDataMutation();
  const { userPreferedDateFormat, preferedDateFormat } = usePreferedDateFormat();
  const [filterObject, setFilterObject] = useState<any>();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data) {
      setRows([]);
      let temp = [];
      if (data && data.selected_data.length > 0) {
        setRowsCount(data.record_count);
        temp = data.selected_data.map((elem: any, index: number) => {
          return {
            ...elem,
            date_of_birth: moment(elem.patient.date_of_birth).format(`${userPreferedDateFormat.toUpperCase()}`),
            id: index
          };
        });
      } else {
        setRowsCount(0);
      }
      setRows(temp);
    }
  }, [data]);
  useEffect(() => {
    if (isError) {
      setRows([]);
      setRowsCount(0);
      const errorData: any = error;
      if (errorData?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      }
    }
  }, [isError]);

  useEffect(() => {
    if (!isLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getEligiblePatientsData({ data: filterObject, from: 0, size: pageSize, status: 'Prescreen Failure' });
      } else {
        getEligiblePatientsData({
          data: filterObject,
          from: pageNumber * pageSize,
          size: pageSize,
          status: 'Prescreen Failure'
        });
      }
    }
  }, [pageNumber, pageSize, filterObject]);

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (data) {
      const tempColumns: any = [
        {
          field: 'Core_FICS_patient_identifier',
          headerName: 'Core FICS Patient Identifier',
          minWidth: 90,
          flex: 1
        },
        {
          field: 'sex',
          headerName: 'Sex',
          width: 80,
          flex: 1
        },
        {
          field: 'date_of_birth',
          headerName: 'Date of Birth',
          minWidth: 100,
          flex: 1,
          type: 'date'
        },
        {
          field: 'eligible_trials',
          headerName: 'Eligible Trials',
          width: 150,
          renderCell: (params: any) => {
            return (
              <>
                {params.row.eligible_trials.length > 1 ? (
                  <Stack direction="column" spacing={0} className="fakeRowColSpan withLeftBorder">
                    {params.row.eligible_trials?.map((trial: any) => (
                      <Box key={`eligible_trials_${trial}`} className="tableCell">
                        {trial}
                      </Box>
                    ))}
                  </Stack>
                ) : (
                  <Stack direction="column" spacing={0} className="fakeRowColSpan">
                    <Box className="tableCell">{params.row.eligible_trials[0]}</Box>
                  </Stack>
                )}
              </>
            );
          },
          valueGetter: (params: any) => {
            return params.row.eligible_trials.join();
          }
        }
      ];
      if (data?.selected_data) {
        let maxLenth = 0;
        data?.selected_data.map((criteriaList: any) => {
          criteriaList.criteria.map((criteriaObjs: any) => {
            if (typeof criteriaObjs == 'object') {
              const criteriaObj = Object.values(criteriaObjs);
              criteriaObj.map((item: any) => {
                item.map((lists: any) => {
                  const nestedList: any = Object.values(lists);
                  let totalLength = 0;
                  for (let i = 0; i < nestedList.length; i++) {
                    totalLength += nestedList[i].length;
                  }
                  if (maxLenth < totalLength) {
                    maxLenth = totalLength;
                  }
                });
              });
            }
          });
        });
        const criteraArray: any = data?.selected_data.map((item: any, index: any) => item.criteria?.length);
        const maxCriteriaObjectIndex = criteraArray.indexOf(Math.max(...criteraArray));
        if (maxCriteriaObjectIndex >= 0) {
          if (data?.selected_data) {
            const criteriaColumns: any = [];
            for (let i = 0; i < maxLenth; i++) {
              criteriaColumns.push({
                field: `criteria_${Number(i + 1)}`,
                headerName: `Criteria ${Number(i + 1)}`,
                width: 90,
                renderCell: (params: any) => {
                  const multiStudyData: any = Object.values(
                    Object.values(params.row.criteria.map((i: any) => (Object.values(i)[0] as any).flat())).map(
                      (item: any) => item[0]
                    )
                  );
                  const toolTipDataMultiStudy = multiStudyData.map((item: any) => Object.values(item).flat());
                  return (
                    <>
                      {params.row.criteria.length > 1 ? (
                        <Stack direction="column" spacing={0} className="fakeRowColSpan">
                          {toolTipDataMultiStudy.map((item: any) => {
                            return item[i] ? (
                              <Box
                                className="tableCell alignCenter"
                                key={`${params.row.eligible_trials[i]}-${item.value}`}
                              >
                                <Tooltip
                                  title={`${item[i].field} ${item[i].operator.replaceAll('_', ' ')} ${
                                    item[i].type === 'DATE' ? preferedDateFormat(item[i].value) : item[i].value
                                  }`}
                                  placement="top"
                                  className="smallfontTooltip"
                                >
                                  <CheckIcon color="primary" />
                                </Tooltip>
                              </Box>
                            ) : (
                              <Box className="tableCell alignCenter emptyGrey" />
                            );
                          })}
                        </Stack>
                      ) : (
                        <>
                          {toolTipDataMultiStudy.map((item: any) => {
                            return item[i] ? (
                              <Stack direction="column" spacing={0} className="fakeRowColSpan">
                                <Box className="tableCell alignCenter">
                                  <Tooltip
                                    title={`${item[i].field} ${item[i].operator.replaceAll('_', ' ')} ${
                                      item[i].type === 'DATE' ? preferedDateFormat(item[i].value) : item[i].value
                                    }`}
                                    placement="top"
                                    className="smallfontTooltip"
                                  >
                                    <CheckIcon color="primary" />
                                  </Tooltip>
                                </Box>
                              </Stack>
                            ) : (
                              <Box className="tableCell alignCenter emptyGrey" />
                            );
                          })}
                        </>
                      )}
                    </>
                  );
                },
                valueGetter: (params: any) => {
                  const multiStudyData: any = Object.values(
                    Object.values(params.row.criteria.map((i: any) => (Object.values(i)[0] as any).flat())).map(
                      (item: any) => item[0]
                    )
                  );
                  const toolTipDataMultiStudy = multiStudyData?.map((item: any) => Object.values(item).flat());
                  const temp = toolTipDataMultiStudy
                    .map((item: any) =>
                      item[i]
                        ? `${item[i].field} ${item[i].operator.replaceAll('_', ' ')} ${
                            item[i].type === 'DATE' ? preferedDateFormat(item[i].value) : item[i].value
                          }`
                        : null
                    )
                    .filter((item: any) => item)
                    .join();
                  return temp;
                }
              });
            }
            tempColumns.push(...criteriaColumns);
          }
          const temp = data?.selected_data.map((elem: any) => {
            return {
              id: elem.patient?.parent_id ? elem.patient?.parent_id : Math.random(),
              parent_id: elem.patient?.parent_id,
              Core_FICS_patient_identifier: elem.patient?.Core_FICS_patient_identifier,
              sex: elem.patient.sex,
              date_of_birth: moment(elem.patient.date_of_birth).format(`${userPreferedDateFormat.toUpperCase()}`),
              eligible_trials: elem.eligible_trials,
              comments: elem.comments.map((item: any) => item && Object.values(item)[0]),
              criteria: elem.criteria
            };
          });
          setRows(temp);
        }
      }
      tempColumns.push({
        field: 'comments',
        headerName: 'Comment',
        minWidth: 240,
        flex: 1,
        renderCell: (params: any) => {
          return (
            <>
              {params.row.comments?.length > 1 ? (
                <Stack direction="column" spacing={0} className="fakeRowColSpan withLeftBorder">
                  {params.row.comments?.map((trial: any, index: any) => (
                    <Tooltip
                      key={`eligible_trials_${trial}`}
                      title={params.row.comments[index]?.length > 30 ? params.row.comments[index] : ''}
                      placement="top"
                    >
                      <Box className="tableCell">
                        <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                          {params.row.comments.length ? params.row.comments[index] : null}
                        </span>
                      </Box>
                    </Tooltip>
                  ))}
                </Stack>
              ) : params.row.comments.length ? (
                params.row.comments[0]
              ) : null}
            </>
          );
        },
        valueGetter: (params: any) => {
          return params.row.comments.join();
        }
      });
      setColumns(tempColumns);
    }
  }, [data, userPreferedDateFormat]);

  const dataTableProps = {
    getRowHeight: () => 'auto',
    sx: {
      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
        py: '2px'
      },
      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
        py: '8px'
      },
      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
        py: '16px'
      }
    },
    initialState: {
      sorting: {
        sortModel: [{ field: 'Core_FICS_patient_identifier', sort: 'asc' }]
      }
    },
    filterMode: 'server'
  };

  const filterValues = (data: any) => {
    setFilterObject(data);
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`Prescreen Fail`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div style={{ display: 'flex', height: '100%' }}>
      <div style={{ flexGrow: 1 }}>
        <DataTable
          height="76vh"
          columns={columns}
          rows={rows}
          hasDefinedColumns
          loading={isLoading}
          setPageSize={setPageSize}
          setPageNumber={setPageNumber}
          disableSelectionOnClick
          pagination
          dataTableProps={dataTableProps}
          paging
          checkboxSelection
          paginationMode="server"
          rowsCount={rowsCount}
          exportCSVName={`Prescreen Fail`}
          datePreference={userPreferedDateFormat}
          page={pageNumber}
          pageSize={pageSize}
          hasDefinedDataGridToolbarExport
          definedGridToolbarExport={definedCustomDatGridExport}
          filterValues={(data: any) => filterValues(data)}
        />
      </div>
    </div>
  );
}
